// ** React Imports
import { type ReactNode } from 'react'

interface IProps {
	children: ReactNode
}

/**
 * fortunai.co is a static marketing website and performs no authentication.
 * Auth initialization (the /users/me check on load) has been intentionally
 * removed — application access happens only through app.fortunai.co.
 */
export const AuthWrapper = ({ children }: IProps) => {
	return <>{children}</>
}
